import { useState, useEffect, useRef } from 'react';
import { checkHandleAvailability } from '@ego/api';

const HANDLE_RE = /^[a-z0-9_]{3,32}$/;

export default function useHandleValidation(handle) {
  const [status, setStatus] = useState('idle'); // idle | checking | available | unavailable | invalid
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (abortRef.current) {
      abortRef.current.abort();
      abortRef.current = null;
    }

    const trimmed = handle?.toLowerCase().trim();
    if (!trimmed) {
      setStatus('idle');
      setError(null);
      return;
    }

    if (!HANDLE_RE.test(trimmed)) {
      setStatus('invalid');
      setError('3-32 characters, lowercase letters, numbers, underscores only');
      return;
    }

    setStatus('checking');
    setError(null);

    const controller = new AbortController();
    abortRef.current = controller;

    const timeout = setTimeout(() => {
      checkHandleAvailability(trimmed)
        .then((result) => {
          if (controller.signal.aborted) return;
          if (result.available) {
            setStatus('available');
            setError(null);
          } else {
            setStatus('unavailable');
            setError('Username unavailable');
          }
        })
        .catch((err) => {
          if (controller.signal.aborted) return;
          setStatus('idle');
          setError(err.message);
        });
    }, 300);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [handle]);

  return { status, error };
}
